import { ReportContext } from '../internal/ReportContext';
import { firstValueFrom, ReplaySubject } from 'rxjs';
import { map, takeUntil, find } from 'rxjs/operators';
import { ReportSession } from '@sas-dvr/ltjs-vav';

export function assertValidContext(
  context: ReportContext | null
): asserts context is ReportContext {
  if (!context) {
    throw new Error('This handle is no longer valid');
  }
}

export async function waitForReportSessionReady(
  context: ReportContext,
  destroyed$: ReplaySubject<boolean>
): Promise<ReportSession> {
  return firstValueFrom(
    context.getSessionStatusNotifier().pipe(
      takeUntil(destroyed$),
      find((status): status is 'ready' | 'error' => status === 'ready' || status === 'error'),
      map((status) => {
        if (status === undefined) {
          throw new Error('Handle was invalidated before the report controller was created.');
        }
        if (status === 'error') {
          throw new Error('An error occurred while loading the report.');
        }
        const rs = context.getReportSession();
        if (!rs) {
          throw new Error('Report session could not be created.');
        }
        return rs;
      })
    )
  );
}
